<template>
    <div>
        <el-button icon="el-icon-back" circle class="back" @click="back"></el-button>
         <div class="body">
             <div class="search">
                 <div class="block" id="container">
                    <span v-for="(item,index) in options" id="index" :key="index" @click="switchs(item)" class="seach-all" :class="{seachchange:changeblue==index}" > {{item.name}} </span>
                </div>
             </div>
         </div>
         <div class="info">
                <component :is="componentType" />
         </div>
    </div>
</template>

<script>

//商品详情

import storeList from './StoreList' //商品列表
import storeImg from './StoreImg' //图片介绍
import storeParameter from './StoreParameter' //商品参数
import storeExplan from './StoreExplan' //商品说明
import storeSlide from './StoreSlide' //商品轮播图
import storeDeduction from './StoreDeduction' //商品抵扣规则
import storePresent from './StorePresent' //礼品列表

import { createNamespacedHelpers } from 'vuex'
const {mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('product')

export default {
    data() {
      return {
        // componentType:'storeDeduction',
        options:[
            {id:0,name:'图片介绍',url:'storeImg'},
            {id:1,name:'产品参数',url:'storeParameter'},
            {id:2,name:'抵扣规则',url:'storeDeduction'},
            {id:3,name:'商品说明',url:'storeExplan'},
            {id:4,name:'轮播图片',url:'storeSlide'},
            {id:5,name:'礼品列表',url:'storePresent'},
        ],
        changeblue:'',
      }
    },
    components:{storeList,storeImg,storeParameter,storeExplan,storeSlide,storeDeduction,storePresent},
    mounted(){
        // console.log(this.componentType)
    },
    computed:{
      ...mapState({
         componentType:state=>state.componentType
      })
    },
    methods: {
        ...mapMutations(['alterStoreType','addProductId','alterComponentType']),
        switchs(item){
            this.alterComponentType(item.url)
            this.changeblue = item.id;
        },
        back(){
              this.alterStoreType('storeList')
        },
    }
};
</script>

<style scoped>

.block{
    height: 50px;
}

.demonstration{
    line-height: 50px;
    width: 200px;
}

.bigTitle{
    text-align: left;
}

.floor{
    width: 15px;
    background-color: #0F86DA;
    color:#0F86DA;
    border-radius: 5px;
}

.body{
    background-color: #FFFFFF;
    border-radius: 10px;
}

.table{
    width: 50%;
}

.head th{
    line-height: 50px;
}

.info{
    margin-top: 1%;
    background-color: #FFFFFF;
}

.color{
    background-color: #0F86DA;
    width: 50px;
    height: 50px;
}


.seach-all {
    /* border-right: 1px solid #ffffff; */
    border-radius:25px;
    display: inline-block;
    margin-top: 10px;
    width: 180px;
    margin-left: 10px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    font-family: ArialMT;
    font-size: 18px;
    color: #ffffff;
    background-color: #dbe3eb;
  }

  .seach-all:last-child {
    border-right: none;
  }

  .seachchange {
    background-color: #409EFF;
  }

  .back{
      margin-right: 90%;
  }

</style>


// WEBPACK FOOTER //
// src/components/Store/StoreInfo.vue